import { render, staticRenderFns } from "./InvoicePrescriber.vue?vue&type=template&id=56fb2999&scoped=true&"
import script from "./InvoicePrescriber.vue?vue&type=script&lang=ts&"
export * from "./InvoicePrescriber.vue?vue&type=script&lang=ts&"
import style0 from "./InvoicePrescriber.vue?vue&type=style&index=0&id=56fb2999&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fb2999",
  null
  
)

export default component.exports